import { Link } from 'react-router-dom';
import { FaEnvelope, FaGithub, FaLinkedin, FaDev, FaYoutube, FaDiscord } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import '../../css/common/footer.css';

function Footer() {
  return (
    <footer >
      <div className="footer-columns container">
        <div className="footer-column">
          <h4 className="no-select">Portfolio</h4>
          <ul>
            <li><a href="https://github.com/dave-sommerville?tab=repositories" target="_blank" rel="noopener noreferrer">Repositories</a></li>
            <li><a href="https://dave-sommerville.github.io/ds-code-releases/data/dave-sommerville-resume-2025.pdf" target="_blank" rel="noopener noreferrer">Resume</a></li>
            <li><Link to="/playground">Portfolio</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4 className="no-select">Info</h4>
          <ul>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/collaborators">Collaborators</Link></li>
            <li className="mb-5"><Link to="/something-else">Something else</Link></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4 className="no-select">Extras</h4>
          <ul>
            <li><a href="https://github.com/dave-sommerville/theForks.io" target="_blank" rel="noopener noreferrer">theForks.io</a></li>
            <li><a href="https://dave-sommerville.github.io/code-breaker/" target="_blank" rel="noopener noreferrer">Code Breaker</a></li>
            <li className="flex space-between w-80px">                        
              <a 
                  href="https://github.com/dave-sommerville" 
                  target="_blank" 
                  rel="noopener noreferrer"
              >
                  <FaGithub></FaGithub>
              </a>
              <a 
                  href="https://www.linkedin.com/in/dave-sommerville/" 
                  target="_blank" 
                  rel="noopener noreferrer"
              >                            
                  <FaLinkedin></FaLinkedin>
              </a>
              <a 
                  href="https://discord.com/users/ds_code" 
                  target="_blank" 
                  rel="noopener noreferrer"
              >                            
                  <FaDiscord></FaDiscord>
              </a>
            </li>
          </ul>
        </div>
      </div>

    </footer>
  );
}

export default Footer;